export const Australian = {
  translation: {
    formattedDate: {
      intlDateTimeShort: "{{ date, short }}",
    },
    body: {
      dateFormat: "Format: dd/mm/yyyy",
      zipLabel: "Postal Code",
      zipValid: "A valid Postal Code must be 4 digits in length.",
    },
    brandInfo: {
      brandName: {
        lifesafer: "LifeSafer",
      },
      brandPhone: {
        lifesafer: "1800-497-033",
      },
      brandPhoneHref: {
        lifesafer: "tel:+1800-497-033",
      },
    },
  },
};
